import { FastField, Field } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomAccordion from 'general/components/Others/CustomAccordion';
import CustomDropdown, { CustomDropdownDirections } from 'general/components/Others/CustomDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import Utils from 'general/utils/Utils';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import AgencyHelper from 'features/Agency/agencyHelper';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import ChargeHelper from 'features/Charge/chargeHelper';
import useRouter from 'hooks/useRouter';
import DropdownMultiChoiceView from 'general/components/quybka/Others/DropdownMultiChoiceView';
import CustomDropdownMultiChoiceView, { CustomDropdownMultiChoiceDirections } from 'general/components/quybka/Others/CustomDropdownMultiChoiceView';
import { AppDialogHelper } from 'general/components/AppDialog';
import UIHelper from 'general/helpers/UIHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';

function PremiseInfoView({
    formikProps,
    premiseDetail,
    selectedAreaProvince,
    setSelectedAreaProvince,
    selectedAreaDistrict,
    setSelectedAreaDistrict,
    commissionGrounds,
    rentalForm,
    setRentalForm,
    readyToValidData,
    setRentalPriceTypeDisabled,
}) {
    const { t } = useTranslation();
    // khu vuc
    const areaTree = useSelector((state) => state.app.areaTree);
    const areaProvinceList = useMemo(() => {
        return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
    }, [areaTree]);
    const areaProvinceOptions = useMemo(() => {
        return _.map(areaProvinceList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaProvinceList]);

    const areaDistrictList = useMemo(() => {
        if (!selectedAreaProvince) return [];
        return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
    }, [areaTree, selectedAreaProvince]);
    const areaDistrictOptions = useMemo(() => {
        return _.map(areaDistrictList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaDistrictList]);

    useEffect(() => {
        if (premiseDetail) {
            const areaId = premiseDetail.areaId;
            const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
            const parentAreaId = area?.parentId;
            const parentArea = ChargeHelper.Utils.getAreaById([areaTree], parentAreaId);
            if (area?.typeCode === 'W') {
                setSelectedAreaDistrict(area);
                if (parentArea?.typeCode === 'P') {
                    setSelectedAreaProvince(parentArea);
                }
            } else if (area?.typeCode === 'P') {
                setSelectedAreaProvince(area);
            }
        }
    }, [premiseDetail, areaTree]);

    const rentingFormOptions = [
        { value: 'Miễn phí', name: 'Miễn phí' },
        { value: 'Có phí', name: 'Có phí' },
    ]

    const handleCheckStation = (station) => {
        if (!premiseDetail?.chargeStations?.map(item => item?.stationCode)?.includes(station?.stationCode) && !!station?.item?.premiseId) {
            AppDialogHelper.show(
                `Đã tồn tại mặt bằng`,
                `Trạm sạc này đã được gắn với một mặt bằng khác. Vui lòng chọn trạm sạc khác.`,
                [
                    {
                        title: 'Hủy bỏ',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                            return false;
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogDeleteVehicle
            );
        } else {
            return true;
        }
    }

    const handleSetLandlordCommission = (type) => {
        const commission = commissionGrounds?.find(commission => commission?.key === type);
        if (!commission?.show) {
            formikProps.setFieldValue('fixEnergyCommissionValueLandlord', commission?.value);
        } else {
            formikProps.setFieldValue('fixEnergyCommissionValueByCar', commission?.car);
            formikProps.setFieldValue('fixEnergyCommissionValueByBike', commission?.bike);
        }
    }

    return (
        <Row>
            <CustomAccordion
                title="Thông tin cơ bản"
                collapsible={false}
                contentClassName="pb-0 pt-4"
                content={
                    <div className="d-flex flex-wrap">
                        <Col md={4} className={`pl-0 pr-lg-2 pr-md-2 pr-0`}>
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Tên mặt bằng')} </span>}
                                inputName="name"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <FastField name="name">
                                        {({ field, form, meta }) => (
                                            <KTFormInput
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                }}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                type={KTFormInputType.text}
                                                placeholder={'Nhập tên mặt bằng'}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                            />
                                        )}
                                    </FastField>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className="px-lg-2 px-md-2 px-0">
                            <KTFormGroup
                                label={<span className="font-weight-boldest" style={{ fontSize: 13, color: AppColors.gray[800] }}>{t('Loại mặt bằng')} </span>}
                                inputName="type"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <Field name="type">
                                        {({ field, form, meta }) => {
                                            return (
                                                <KTBSDropdown
                                                    toggleElement={({ showError }) => (
                                                        <button
                                                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                                            type="button"

                                                        >
                                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {field?.value ? commissionGrounds?.find(commission => commission?.key === field?.value)?.name : 'Chọn loại mặt bằng'}
                                                            </span>
                                                        </button>
                                                    )}
                                                    selectedValue={field?.value}
                                                    dropdownMenuItems={
                                                        commissionGrounds?.map((commission) => ({
                                                            name: commission.name,
                                                            value: commission?.key,
                                                        })) || []
                                                    }
                                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                    dropdownMenuClassName="overflow-auto w-100"
                                                    onChange={(value) => {
                                                        form.setFieldValue(field.name, value)
                                                        handleSetLandlordCommission(value);
                                                    }}
                                                    onBlur={() => form.setFieldTouched(field.name, true)}
                                                    enableCheckValid
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    isDropdownForm={true}
                                                />
                                            )
                                        }}
                                    </Field>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className={`pl-lg-2 pl-md-2 pl-0 pr-0`}>
                            <KTFormGroup
                                label={<span className="font-weight-boldest" style={{ fontSize: 13, color: AppColors.gray[800] }}>{t('Diện tích')}</span>}
                                inputName="floorArea"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <FastField name="floorArea">
                                        {({ field, form, meta }) => (
                                            <KTFormInput
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => form.setFieldValue(field.name, value)}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                type={KTFormInputType.currency}
                                                placeholder={'Nhập số'}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                unit="m2"
                                            />
                                        )}
                                    </FastField>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className='pr-lg-2 pr-md-2 pr-0 pl-0' >
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Loại phương tiện')}</span>}
                                inputName="vehicleTypes"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <FastField name="vehicleTypes">
                                        {({ field, form, meta }) => (
                                            <DropdownMultiChoiceView
                                                items={ChargeHelper.Data.vehicleTypeOptions}
                                                initialSelectedValues={field.value?.length > 0 ? field.value?.split(',') : []}
                                                onChange={(items) => {
                                                    form.setFieldValue(field.name, items?.join(','))
                                                    if (!items?.includes('CAR')) {
                                                        formikProps.setFieldValue('parkingSlots', 0);
                                                    }
                                                }}
                                                hasCheckAll={false}
                                                placeholder='Chọn loại phương tiện'
                                                readyToValidData={readyToValidData}
                                            />
                                        )}
                                    </FastField>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className='px-lg-2 px-md-2 px-0' >
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Phạm vi thuê')}</span>}
                                inputName="rentingType"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <Field name="rentingType">
                                        {({ field, form, meta }) => (
                                            <KTBSDropdown
                                                name="rentingType"
                                                toggleElement={
                                                    <button
                                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                                            ${!formikProps.values.vehicleTypes?.split(',')?.includes('CAR') ? 'disabled' : ''}`}
                                                        type="button"
                                                    >
                                                        {_.find(
                                                            AgencyHelper.Data.rentingTypeOptions,
                                                            (item) => item.value === field.value
                                                        )?.name ?? 'Chọn phạm vi thuê'}
                                                    </button>
                                                }
                                                selectedValue={field.value}
                                                dropdownMenuItems={AgencyHelper.Data.rentingTypeOptions}
                                                dropdownMenuClassName="overflow-auto w-100"
                                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                onChange={(value) => {
                                                    form.setFieldValue(field.name, value)
                                                    if (value === 'FULL') {
                                                        formikProps.setFieldValue('parkingSlots', 0);
                                                    }
                                                }}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                isDropdownForm={true}
                                                disabled={!formikProps.values.vehicleTypes?.split(',')?.includes('CAR')}
                                            />
                                        )}
                                    </Field>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className={`pr-0 pl-lg-2 pl-md-2 pl-0`}>
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Số chỗ đỗ xe ô tô')} </span>}
                                inputName="parkingSlots"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <Field name="parkingSlots">
                                        {({ field, form, meta }) => (
                                            <KTFormInput
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => form.setFieldValue(field.name, value)}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                type={KTFormInputType.currency}
                                                placeholder={t('enterNumber')}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                unit='Chỗ đỗ'
                                                disabled={!!formikProps.values.vehicleTypes
                                                    ? !formikProps.values.vehicleTypes?.split(',')?.includes('CAR')
                                                    : true
                                                }
                                            />
                                        )}
                                    </Field>
                                }
                                isRequired={!(!!formikProps.values.vehicleTypes
                                    ? !formikProps.values.vehicleTypes?.split(',')?.includes('CAR') || formikProps.values.rentingType === 'FULL'
                                    : true)}
                            />
                        </Col>
                        <Col md={4} className='pr-lg-2 pr-md-2 pr-0 pl-0' >
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Hình thức thuê')}</span>}
                                inputName="rentalForm"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <Field name="rentalForm">
                                        {({ field, form, meta }) => (
                                            <KTBSDropdown
                                                name="rentalForm"
                                                toggleElement={
                                                    <button
                                                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                                        type="button"
                                                    >
                                                        {_.find(
                                                            rentingFormOptions,
                                                            (item) => item.value === rentalForm
                                                        )?.name ?? 'Chọn hình thức thuê'}
                                                    </button>
                                                }
                                                selectedValue={rentalForm}
                                                dropdownMenuItems={rentingFormOptions}
                                                dropdownMenuClassName="overflow-auto w-100"
                                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                onChange={(value) => {
                                                    setRentalForm(value);
                                                    form.setFieldValue(field.name, value);
                                                    if (value === 'Miễn phí') {
                                                        formikProps.setFieldValue('energyCommissionValue', 0);
                                                    }
                                                }}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                isDropdownForm={true}
                                            />
                                        )}
                                    </Field>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className="px-lg-2 px-md-2 px-0">
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('city')}</span>}
                                inputName="city"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <Field name="city">
                                        {({ field, form, meta }) => (
                                            <KTBSDropdown
                                                toggleElement={({ showError }) => (
                                                    <button
                                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedAreaProvince && readyToValidData
                                                            ? 'button-invalid'
                                                            : ''
                                                            }`}
                                                        type="button"
                                                    >
                                                        {selectedAreaProvince?.name ?? 'Chọn tỉnh/thành phố'}
                                                    </button>
                                                )}
                                                selectedValue={selectedAreaProvince?.areaId}
                                                dropdownMenuItems={areaProvinceOptions}
                                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                dropdownMenuClassName="overflow-auto w-100"
                                                onChange={(value) => {
                                                    setSelectedAreaProvince(_.find(areaProvinceList, (item) => item.areaId === value));
                                                    setSelectedAreaDistrict(null);
                                                    const province = _.find(areaProvinceList, (item) => item.areaId === value);
                                                    formikProps.setFieldValue('areaId', province?.areaId);
                                                }}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                isDropdownForm={true}
                                                searchable={true}
                                                searchFormClassName="mx-3 mt-3 search-form-border"
                                                onUnCheck={() => {
                                                    setSelectedAreaProvince(null);
                                                    setSelectedAreaDistrict(null);
                                                    formikProps.setFieldValue('areaId', null);
                                                }}
                                            />
                                        )}
                                    </Field>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className="pr-0 pl-lg-2 pl-md-2 pl-0">
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('district')} </span>}
                                inputName="district"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <Field name="district">
                                        {({ field, form, meta }) => (
                                            <KTBSDropdown
                                                toggleElement={({ showError }) => (
                                                    <button
                                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedAreaDistrict && readyToValidData
                                                            ? 'button-invalid'
                                                            : ''
                                                            }`}
                                                        type="button"
                                                    >
                                                        {selectedAreaDistrict?.name ?? 'Chọn phường/xã'}
                                                    </button>
                                                )}
                                                selectedValue={selectedAreaDistrict?.areaId}
                                                dropdownMenuItems={areaDistrictOptions}
                                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                dropdownMenuClassName="overflow-auto w-100"
                                                onChange={(value) => {
                                                    const area = _.find(areaDistrictList, (item) => item.areaId === value);
                                                    setSelectedAreaDistrict(area);
                                                    formikProps.setFieldValue('areaId', area?.areaId);
                                                }}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                isDropdownForm={true}
                                                searchable={true}
                                                searchFormClassName="mx-3 mt-3 search-form-border"
                                                onUnCheck={() => {
                                                    setSelectedAreaDistrict(null);
                                                    formikProps.setFieldValue('areaId', selectedAreaProvince?.areaId);
                                                }}
                                            />
                                        )}
                                    </Field>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={12} className="px-0">
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Địa chỉ cụ thể')} </span>}
                                inputName="address"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <FastField name="address">
                                        {({ field, form, meta }) => (
                                            <KTFormInput
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => form.setFieldValue(field.name, value)}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                type={KTFormInputType.text}
                                                placeholder={'Nhập số nhà, tên đường, thôn/xóm'}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                            />
                                        )}
                                    </FastField>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={12} className="px-0">
                            <KTFormGroup
                                label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Mô tả')} </span>}
                                inputName="description"
                                additionalClassName=" mb-4"
                                inputElement={
                                    <FastField name="description">
                                        {({ field, form, meta }) => (
                                            <KTFormTextArea
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => form.setFieldValue(field.name, value)}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                rows={3}
                                                enableCheckValid
                                                placeholder={'Nhập mô tả'}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                            />
                                        )}
                                    </FastField>
                                }
                            />
                        </Col>
                    </div>
                }
            />

            <CustomAccordion
                className="mt-4"
                title="Thông tin liên quan"
                collapsible={true}
                content={
                    <div className="d-flex flex-wrap">
                        <Col md={4} className="pl-0 pr-lg-2 pr-md-2 pr-0">
                            <KTFormGroup
                                label={<span className="font-weight-boldest" style={{ fontSize: 13, color: AppColors.gray[800] }}>{t('Chủ mặt bằng')} </span>}
                                inputName="landlord"
                                additionalClassName=" mb-0"
                                inputElement={
                                    <FastField name="landlord">
                                        {({ field, form, meta }) => (
                                            <CustomDropdown
                                                id={field.name}
                                                toggleElement={({ showError }) => (
                                                    <button
                                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                                        type="button"
                                                    >
                                                        {field.value?.name ?? 'Chọn chủ mặt bằng'}
                                                    </button>
                                                )}
                                                selectedValue={field.value}
                                                dropdownMenuItems={[]}
                                                getSubItems={async (item) => {
                                                    try {
                                                        return await AgencyHelper.API.requestGetAgencyList(
                                                            Utils.filterParams({
                                                                role: item?.role,
                                                                page: item?.page || 0,
                                                                limit: 10,
                                                                q: item?.q || '',
                                                            })
                                                        ).then((data) => {
                                                            return { values: data.agencies, total: data.total };
                                                        });
                                                    } catch (error) {
                                                        console.error('Error fetching agency list:', error);
                                                        return { values: [], total: 0 };
                                                    }
                                                }}
                                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                dropdownMenuClassName="overflow-auto w-100"
                                                onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                }}
                                                onBlur={() => form.setFieldTouched(field.name, true)}
                                                enableCheckValid
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                                isDropdownForm={true}
                                                searchable={true}
                                                searchFormClassName="mx-3 my-1 search-form-border"
                                                defaultValue={{ name: 'Chủ mặt bằng', role: 'LANDLORD' }}
                                                ignoreConfirmClick={true}
                                                subTitleType='email'
                                                direction={CustomDropdownDirections.up}
                                            />
                                        )}
                                    </FastField>
                                }
                                isRequired={true}
                            />
                        </Col>
                        <Col md={4} className="px-lg-2 px-md-2 px-0">
                            <KTFormGroup
                                label={UIHelper.buildFormLabel(t('Mã trạm sạc'), !!premiseDetail?.agencyId)}
                                inputName="stationCode"
                                additionalClassName=" mb-0"
                                inputElement={
                                    <FastField name="stationCode">
                                        {({ field, form, meta }) => {
                                            return (
                                                <CustomDropdownMultiChoiceView
                                                    id={field.name}
                                                    toggleElement={({ showError }) => (
                                                        <button
                                                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                                            style={{
                                                                overflowX: 'auto',
                                                                overflowY: 'hidden'
                                                            }}
                                                            type="button"
                                                        >
                                                            {field.value?.length > 0 ? field.value.map(item => item.stationCode).join(', ') : 'Chọn mã trạm sạc'}
                                                        </button>
                                                    )}
                                                    selectedValue={field.value}
                                                    dropdownMenuItems={[]}
                                                    getSubItems={async (item) => {
                                                        try {
                                                            return await ChargeHelper.API.requestGetChargeStationList(
                                                                Utils.filterParams({
                                                                    role: item?.role,
                                                                    page: item?.page || 0,
                                                                    limit: 10,
                                                                    q: item?.q || '',
                                                                    excludeInvestor: 1,
                                                                })
                                                            ).then((data) => {
                                                                const values = data.chargeStations?.map((station) => ({
                                                                    stationId: station?.stationId,
                                                                    stationCode: station?.stationCode,
                                                                    name: station?.name,
                                                                    item: station,
                                                                    address: ChargeHelper.Utils.getChargeStationFullAddress(station),
                                                                }));
                                                                return { values: values, total: data.total };
                                                            });
                                                        } catch (error) {
                                                            console.error('Error fetching agency list:', error);
                                                            return { values: [], total: 0 };
                                                        }
                                                    }}
                                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                    dropdownMenuClassName="overflow-auto w-100"
                                                    onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                        if (field.value?.length) setRentalPriceTypeDisabled(false);
                                                        else {
                                                            setRentalPriceTypeDisabled(true);
                                                            formikProps.setFieldValue('rentalPriceType', 'Phí thuê cố định')
                                                            formikProps.setFieldValue('energyCommissionValue', 0);
                                                        }
                                                    }}
                                                    onBlur={() => form.setFieldTouched(field.name, true)}
                                                    enableCheckValid
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    isDropdownForm={true}
                                                    searchable={true}
                                                    searchFormClassName="mx-3 my-1 search-form-border"
                                                    defaultValue={{ name: 'Trạm sạc', role: 'CHARGE_STATION' }}
                                                    titleType='stationCode'
                                                    subTitleType='address'
                                                    ignoreConfirmClick={true}
                                                    direction={CustomDropdownMultiChoiceDirections.up}
                                                    idCheckType='stationId'
                                                    handleCheckInput={handleCheckStation}
                                                />
                                            )
                                        }}
                                    </FastField>
                                }
                            />
                        </Col>
                        <Col md={4} className="pl-lg-2 pl-md-2 pl-0 pr-0">
                            <KTFormGroup
                                label={<span className="font-weight-boldest" style={{ fontSize: 13, color: AppColors.gray[800] }}>{t('Đơn hàng liên quan')} </span>}
                                inputName="saleId"
                                additionalClassName=" mb-0"
                                inputElement={
                                    <FastField name="saleId">
                                        {({ field, form, meta }) => {
                                            return (
                                                <KTBSDropdown
                                                    toggleElement={({ showError }) => (
                                                        <button
                                                            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between dropdown-disabled ${showError ? 'border-invalid' : ''}`}
                                                            type="button"
                                                        >
                                                            {field?.value ? `SALE${field?.value?.toString().padStart(8, '0')}` : 'Chọn đơn hàng liên quan'}
                                                        </button>
                                                    )}
                                                    selectedValue={field?.value}
                                                    dropdownMenuItems={[]}
                                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                    dropdownMenuClassName="overflow-auto w-100"
                                                    onChange={(value) => form.setFieldValue(field.name, value)}
                                                    onBlur={() => form.setFieldTouched(field.name, true)}
                                                    enableCheckValid
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    isDropdownForm={true}
                                                    disabled={true}
                                                />
                                            )
                                        }}
                                    </FastField>
                                }
                            />
                        </Col>
                    </div>
                }
            />
        </Row>
    );
};

export default PremiseInfoView;